import FastClick from 'fastclick';

FastClick.prototype.focus = function (targetElement) {
  targetElement.focus();
};

document.addEventListener(
  'DOMContentLoaded',
  () => {
    FastClick.attach(document.body);
  },
  false,
);
